import React from 'react';

import { DepartmentsTree } from '@vlabs/monokit/entities/departments';
import { useGoToDepartment } from '@vlabs/monokit/features/go-to-department';
import { CreateDepartmentButton, CreateDepartmentIconButton } from '@vlabs/monokit/features/point/create-department';
import { useHasPermission } from '@vlabs/permissions';

import { useDepartmentsPageTranslation } from '../i18n';
import { DepartmentAside } from './DepartmentAside';
import { DepartmentContent } from './DepartmentContent';
import { DepartmentEmpty } from './DepartmentEmpty';
import st from './DepartmentsBody.module.sass';

function DepartmentsBody(): React.JSX.Element {
  const { t } = useDepartmentsPageTranslation();
  const { currentDepartmentId, goToDepartment } = useGoToDepartment();
  const canCreateDepartment = useHasPermission('departments', 'create');

  return (
    <div className={st.Root}>
      <DepartmentsTree
        emptyContent={(
          <div className={st.EmptyDepartments}>
            <span>{t('empty', { context: 'tree' })}</span>
            {!!canCreateDepartment && <CreateDepartmentButton onCreateDepartment={goToDepartment} />}
          </div>
        )}
        onSelect={(departmentId) => goToDepartment(
          // если идем по уже выбранному подразделению, то убираем его из параметров
          departmentId === currentDepartmentId ? undefined : departmentId,
        )}
        renderAction={canCreateDepartment ? ({ key }) => (
          <CreateDepartmentIconButton
            onCreateDepartment={goToDepartment}
            parentDepartmentId={key}
          />
        ) : undefined}
        selectedDepartmentId={currentDepartmentId}
      />

      {!!currentDepartmentId && (
        <React.Fragment>
          <DepartmentContent departmentId={currentDepartmentId} />
          <DepartmentAside departmentId={currentDepartmentId} />
        </React.Fragment>
      )}

      {!currentDepartmentId && (
        <DepartmentEmpty />
      )}
    </div>
  );
}

export { DepartmentsBody };
